import { AppState, Auth0Provider } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import config from "../config";
import { IdentityAuth0Provider } from "../components/auth/identity-auth0-context";

type AuthProviderProps = {
  children: React.ReactNode;
};

const AuthProvider = ({ children }: AuthProviderProps) => {
  const auth0Config = config.auth0;
  const navigate = useNavigate();

  const onRedirectCallback = (appState?: AppState) => {
    const target = appState?.returnTo || globalThis.location.pathname;
    navigate(target, { replace: true });
  };

  return (
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      useRefreshTokens
      authorizationParams={{
        audience: auth0Config.audience,
        redirect_uri: `${globalThis.location.origin}/callback`,
      }}
      onRedirectCallback={onRedirectCallback}
    >
      <IdentityAuth0Provider>{children}</IdentityAuth0Provider>
    </Auth0Provider>
  );
};

export default AuthProvider;
